var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"ml-0 mr-0",attrs:{"border":"left","type":"info","text":"","color":"secondary"}},[_c('ParagraphBlock',{attrs:{"html":_vm.text.content}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }